// 商城牵引凑单 AB实验 https://abtest-sgp.corp.kuaishou.com/ab2#/experiment/analysis/7011/detail?tab=2&docType=12
import { useEffect, useState } from 'react';
import { getKSwitch } from '@/common/kswitch';

// 缓存，避免多次请求
let couponMakeupCache;

export function useCouponMakeup() {
    const [couponMakeup, setCouponMakeup] = useState({
        couponPageType: 1,
        couponUsePage: false,
        init: false,
    });

    const getABTest = async () => {
        try {
            const res = await getKSwitch([
                {
                    key: 'coupon_page_type', // 凑单页样式
                },
                {
                    key: 'new_coupon_use_page', // 是否跳新的券核销页
                },
            ]);

            const couponPageType = res[0]?.value || 1;
            const couponUsePage = res[1]?.value || false;

            couponMakeupCache = {
                couponPageType,
                couponUsePage,
                init: true,
            };
            setCouponMakeup(couponMakeupCache);
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        if (couponMakeupCache !== undefined) {
            setCouponMakeup(couponMakeupCache);
            return;
        } else {
            getABTest();
        }
    }, []);

    return {
        couponMakeup,
    };
}
